export default __webpack_public_path__ + "static/my_resume-0c059d01ae844e1ccf1eed735dc56c3c.pdf";